import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Create an RTL cache
const cacheRtl = createCache({
  key: "mui-rtl",
  stylisPlugins: [],
});

// Define an RTL theme
const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "DibajFaNum, Roboto, Arial, sans-serif",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CacheProvider value={cacheRtl}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </CacheProvider>
);
